export function uniquestring() {
  return Math.random().toString(36).substr(2);
}
